import { useQuery } from "@tanstack/react-query";

import { fetchBiometric, type BiometricData } from "@/api/adapters/patients";
import type { PatientListItem } from "@/api/adapters/patients";

/**
 * Hook: fetch biometric data for a patient.
 */
export function useBiometric(patient: PatientListItem | null) {
	return useQuery<BiometricData>({
		queryKey: ["biometric", patient?.uid],
		queryFn: () => fetchBiometric(patient!),
		enabled: !!patient,
		staleTime: 60_000,
	});
}
